import {
    Box,
    Grid,
    Button,
    Dialog,
    IconButton,
    Divider,
    Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import React, { useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import get from 'lodash/get';
import dayjs from 'dayjs';

import DateTimePickerUi from '../../../components/form/DatePickerTimeUi';

const Alert = ({
    __,
    open,
    close,
    selected,
    onUpdate
}) => {

    const formikRef = useRef();

    const selectedDate = get(selected, "deliveryDate");

    const initialValues = {
        deliveryPointDate: get(selected, "deliveryDate"),
    };

    const onSubmit = (values) => {
        console.log(values)
        const newDeliveryDate = get(values, "deliveryPointDate");
        const updatedCallBackPointDetail = {
            ...selected, 
            deliveryDate: newDeliveryDate 
        };
        console.log("Envio: ", updatedCallBackPointDetail)
      //  onUpdate(updatedCallBackPointDetail);
        //close();
    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={initialValues} 
            onSubmit={onSubmit} 
        >
            {formik => (
                <Dialog close={close} open={open} maxWidth="lg" fullWidth>
                    <form onSubmit={formik.handleSubmit}>
                        <Box>
                            <IconButton
                                aria-label="close"
                                onClick={close}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Box className='px-6'>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                                {__(`labels.17`)}
                            </Typography>
                            <Divider />
                        </Box>
                        <Box className='flex flex-col justify-center m-6'>
                            <Grid>
                                <DateTimePickerUi
                                    formik={formik}
                                    name="deliveryPointDate"
                                    label={__(`form.deliveryPointDate.label`)}
                                    placeholder={__(`form.deliveryPointDate.placeholder`)}
                                    defaultValue={dayjs(selectedDate)}
                                />
                            </Grid>
                        </Box>
                        <Box className="m-6"  display="flex" justifyContent="flex-end">
                        <LoadingButton variant="contained" color="secondary" type="submit">{__(`action.save`)}</LoadingButton>
                        </Box>
                </form>
            </Dialog>
            )}
        </Formik>
    );
}

export default Alert;
